<template>
  <div
    class="at-a-glance-table__row column-one"
    :class="isLastRow && !fromReport ? 'add-curve' : ''"
    @click="viewReport()"
  >
    <span :class="getTitleClass">{{ rowData.CompanyName }}</span>
    <span v-if="!fromReport && !isGlobal" class="pop-out">
      <BaseTooltip
        :fromTrendsReport="true"
        placement="top"
        xAlign="center"
        yAlign="top"
        contentWidth="fit-content"
        :fromArticle="true"
        class="tr-report-component__tooltip"
        tooltipColor="white"
      >
        <template #display>
          <img src="/images/pop-out-blue.png" />
        </template>
        <template #tooltip>
          <p>View Full Article</p>
        </template>
      </BaseTooltip>
    </span>
  </div>
  <div class="at-a-glance-table__row column-two">
    <TrendsReportROCTableChart
      :rowData="rowData"
      :fromReport="fromReport"
      :isGlobal="isGlobal"
    />
  </div>
  <div class="at-a-glance-table__row column-three">
    <TrendsReportDTTableChart
      :rowData="rowData"
      :fromReport="fromReport"
      :isGlobal="isGlobal"
    />
  </div>
  <div class="at-a-glance-table__row column-four">
    <span :class="`phase-${rowData.Current ? rowData.CurrentPhase : ''}`">
      {{ rowData.Current }}
    </span>
  </div>
  <div class="at-a-glance-table__row column-five">
    <span :class="`phase-${rowData.ColumnOne ? rowData.ColumnOnePhase : ''}`">
      {{ rowData.ColumnOne }}
    </span>
  </div>
  <div class="at-a-glance-table__row column-six">
    <span :class="`phase-${rowData.ColumnTwo ? rowData.ColumnTwoPhase : ''}`">
      {{ rowData.ColumnTwo }}
    </span>
  </div>
  <div class="at-a-glance-table__row column-seven">
    <span
      :class="`phase-${rowData.ColumnThree ? rowData.ColumnThreePhase : ''}`"
    >
      {{ rowData.ColumnThree }}
    </span>
  </div>
  <div
    class="at-a-glance-table__row column-eight"
    :class="isLastRow && !fromReport ? 'add-curve' : ''"
  >
    <div class="highlight-container">
      <div class="highlight-text" v-if="hasHighlight" v-html="highlightText" />
      <div v-if="!hasHighlight && fromDashboard"></div>
      <div
        v-if="!fromReport"
        @click="
          isFavorite ? $emit('remove-aag', rowData) : $emit('add-aag', rowData)
        "
      >
        <BaseTooltip
          :fromTrendsReport="true"
          placement="top"
          xAlign="center"
          yAlign="top"
          contentWidth="small"
          :fromArticle="true"
          class="tr-report-component__tooltip"
          tooltipColor="white"
          :centered="true"
        >
          <template #display>
            <IconRemoveAAG v-if="isFavorite" />
            <IconAddAAG v-else />
          </template>
          <template #tooltip>
            <p v-if="isFavorite">Remove From My At-a-Glance</p>
            <p v-else>Add To My At-a-Glance</p>
          </template>
        </BaseTooltip>
      </div>
    </div>
  </div>
</template>

<script>
  import TrendsReportDTTableChart from '~/components/trendsreport/TrendsReportDTTableChart.vue';
  import TrendsReportROCTableChart from '~/components/trendsreport/TrendsReportROCTableChart.vue';
  import IconAddAAG from '~/components/icon/IconAddAAG.vue';
  import IconRemoveAAG from '~/components/icon/IconRemoveAAG.vue';
  import BaseTooltip from '~/components/base/BaseTooltip.vue';
  import { useAAGStore } from '~/stores/aag';

  export default {
    name: 'AtAGlanceIndicatorTableRow',
    emits: ['add-aag', 'remove-aag'],
    components: {
      TrendsReportDTTableChart,
      TrendsReportROCTableChart,
      IconAddAAG,
      IconRemoveAAG,
      BaseTooltip,
    },
    props: {
      fromDashboard: {
        type: Boolean,
        default: false,
      },
      headerRow: {
        type: Boolean,
        default: false,
      },
      rowData: {
        type: Object,
        required: true,
      },
      firstRow: {
        type: Boolean,
        default: false,
      },
      isLastRow: {
        type: Boolean,
        default: false,
      },
      fromReport: {
        type: Boolean,
        default: false,
      },
      hasHighlight: {
        type: Boolean,
        default: true,
      },
      isGlobal: {
        type: Boolean,
        default: false,
      },
    },
    mounted() {},
    data: () => ({
      hide: false,
    }),
    setup() {
      const aagStore = useAAGStore();
      return { aagStore };
    },
    computed: {
      highlightText() {
        if (!this.rowData.Highlight) return '';
        return this.rowData.Highlight;
      },
      getTitleClass() {
        if (this.isGlobal) {
          return 'title global';
        }
        if (this.fromReport && !this.hasHighlight) {
          return 'title';
        }
        if (!this.fromReport && this.hasHighlight) {
          return 'title-short';
        }
        return 'title';
      },
      aagFavorites() {
        return this.aagStore.aagFavoriteGetter;
      },
      isFavorite() {
        if (this.fromDashboard) return true;
        for (const aagItem of this.aagFavorites) {
          if (
            this.rowData.DOSCode == aagItem.DOSCode &&
            this.rowData.IsGlobal == aagItem.IsGlobal
          ) {
            return true;
          }
        }
        return false;
      },
    },
    methods: {
      viewReport() {
        if (this.isGlobal) {
          return;
        }
        window.location.href = `${this.rowData.Link}/${this.rowData.TREditionID}`;
      },
    },
  };
</script>

<style lang="scss" scoped>
  .at-a-glance-table {
    font-family: 'Open Sans', sans-serif !important;
    &__row {
      display: flex;
      align-items: center;
      justify-content: center;
      min-height: 63px;
      &.column-one {
        font-family: 'Open Sans', sans-serif !important;
        border-left: 1px solid var(--itr-tr-grey);
        font-size: 16px;
        font-weight: 700;
        justify-content: flex-start;
        padding: 6px 16px;
        line-height: 1.2;
        color: var(--itr-blue-dark);
        .pop-out {
          margin-left: 12px;
          margin-top: 4px;
        }
        .title {
          max-width: 85%;
          cursor: pointer;
        }
        .title-short {
          max-width: 85%;
          cursor: pointer;
        }
        .global {
          cursor: text;
        }
        &.add-curve {
          border-bottom-left-radius: 8px;
        }
      }
      &.column-eight {
        border-right: 1px solid var(--itr-tr-grey);
        font-size: 14px;
        line-height: 18px;
        justify-content: flex-start;
        padding: 6px 16px;
        &.add-curve {
          border-bottom-right-radius: 8px;
        }
        .highlight-container {
          width: 100%;
          display: flex;
          justify-content: space-between;
          align-items: center;
          gap: 16px;
          .tr-report-component__tooltip {
            cursor: pointer;
          }
        }
      }
      &.column-two,
      &.column-three,
      &.column-four,
      &.column-five,
      &.column-six,
      &.column-seven {
        font-family: 'Open Sans', sans-serif !important;
      }
      .phase-A {
        color: var(--itr-white);
        background: var(--itr-tr-blue);
        font-weight: bold;
        font-size: 14px;
        height: calc(100% - 12px);
        width: calc(100% - 10px);
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .phase-B {
        color: var(--itr-white);
        background: var(--itr-tr-green);
        font-weight: bold;
        font-size: 14px;
        height: calc(100% - 12px);
        width: calc(100% - 10px);
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .phase-C {
        color: var(--itr-white);
        background: var(--itr-tr-orange);
        font-weight: bold;
        font-size: 14px;
        height: calc(100% - 12px);
        width: calc(100% - 10px);
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .phase-D {
        color: var(--itr-white);
        background: var(--itr-tr-red);
        font-weight: bold;
        font-size: 14px;
        height: calc(100% - 12px);
        width: calc(100% - 10px);
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .hide {
        display: none;
      }
    }
  }
  .highlight-text {
    * {
      font-size: 14px !important;
      color: var(--itr-charcoal) !important;
      background-color: transparent !important;
      font-family: 'Open Sans', sans-serif !important;
    }
  }
  .at-a-glance-table__row {
    border-bottom: 1px solid var(--itr-tr-grey);
  }
</style>
